import { EndpointSetting } from "@/constants/app/type";
import { groupEsimPackages } from "@/utils/esim/groupEsimPackages";
import { EsimState } from "../types";

export const callbackEsimCatalogPublicList: EndpointSetting["caller"] = (
  state: EsimState,
  action,
) => {
  const payload = action.payload ?? {};
  const packages = payload.esims ?? [];
  state.esim_catalog_public_list.data.packages = packages;
  state.esim_catalog_public_list.data.totalRecords = payload.pagination?.total ?? packages.length;
  state.esim_catalog_public_list.data.groups = groupEsimPackages(packages);
};
